import { dataset, projectId } from "./config";
import {
  postquery,
  //limitquery,
  paginatedquery,
  configQuery,
  singlequery,
  pathquery,
  allauthorsquery,
  authorsquery,
  postsbyauthorquery,
  postsbycatquery,
  catpathquery,
  catquery,
  getAll,
  //searchquery
} from "./groq";

import sanityClient  from "@sanity/client"; //from "next-sanity";
import { sanityHostConfig } from "../paths";

const client = sanityClient({
  projectId: projectId, // find this at manage.sanity.io, run `sanity init` to initialize
  dataset: dataset, // this is from when we answered those question from 'sanity init'
  useCdn: true,
  // Same-origin proxy under /blogi, so the blog does not depend on
  // www.laatulakki.fi being added to Sanity's CORS allowlist. See lib/paths.js.
  ...sanityHostConfig,
});


if (!projectId) {
  console.error(
    "The Sanity Project ID is not set. Check your environment variables."
  );
}

/**
 * Checks if it's safe to create a client instance, as `@sanity/client` will throw an error if `projectId` is false
 */


/*
const client = projectId
  ? createClient({ projectId, dataset, apiVersion, useCdn })
  : null;
  */

export const fetcher = async ([query, params]) => {
  return client ? client.fetch(query, params) : [];
};


(async () => {
  if (client) {
    const data = await client.fetch(getAll);
    if (!data || !data.length) {
      console.error(
        "Sanity returns empty array. Are you sure the dataset is public?"
      );
    }
  }
})();

export async function getAllPosts() {
  if (client) {
    return (await client.fetch(postquery)) || [];
  }
  return [];
}

export async function getSettings() {
  if (client) {
    return (await client.fetch(configQuery)) || [];
  }
  return [];
}

export function getPostBySlug(slug) {
  if (client) {
    return ( client.fetch(singlequery, { slug })) || {};
  }
  return {};
}

export async function getPostBySlugNew(slug) {
  try {
    const response = await client.fetch(singlequery, { slug });
    return response[0] || {};
  } catch (error) {
    console.error('Error fetching post:', error);
    return {};
  }
}

export async function getAllPostsSlugs() {
  if (client) {
    const slugs = (await client.fetch(pathquery)) || [];
    return slugs.map(slug => ({ slug }));
  }
  return [];
}
// Author
export async function getAllAuthorsSlugs() {
  if (client) {
    const slugs = (await client.fetch(authorsquery)) || [];
    return slugs.map(slug => ({ author: slug }));
  }
  return [];
}

export async function getAuthorPostsBySlug(slug) {
  if (client) {
    return (await client.fetch(postsbyauthorquery, { slug })) || {};
  }
  return {};
}

export async function getAllAuthors() {
  if (client) {
    return (await client.fetch(allauthorsquery)) || [];
  }
  return [];
}

// Category

export async function getAllCategories() {
  if (client) {
    const slugs = (await client.fetch(catpathquery)) || [];
    return slugs.map(slug => ({ category: slug }));
  }
  return [];
}

export async function getPostsByCategory(slug) {
  if (client) {
    return (await client.fetch(postsbycatquery, { slug })) || {};
  }
  return {};
}

export async function getTopCategories() {
  if (client) {
    return (await client.fetch(catquery)) || [];
  }
  return [];
}

export async function getPaginatedPosts(limit) {
  if (client) {
    return (
      (await client.fetch(paginatedquery, {
        pageIndex: 0,
        limit: limit
      })) || {}
    );
  }
  return {};
}
